module.exports = __webpack_public_path__ + "static/media/SDC.1b6f7669.jpg";